import {Component} from "@angular/core";

@Component({
  template: `<h1>PAGE NOT FOUND</h1>`
})
export class PageNotFoundComponent{

}


// WEBPACK FOOTER //
// ./src/app/errors/page-not-found.component.ts